export default __webpack_public_path__ + "static/media/login-bg-35.1a74839a.jpg";